import { LuTrash2 } from 'react-icons/lu'
import { Box, Flex } from '@chakra-ui/react'
import { Order, OrderPaymentStatus } from '@leid/api-orders'

import SummaryPriceInfo from 'components/partials/shared/Cart/SummaryPriceInfo'
import { OrderCardDeleteButton } from 'components/ui/ItemCard/styles'
import { Loader } from 'components/ui/Loader'
import { useCustomerInfo } from 'hooks/useCustomerInfo'

import { PayButtons } from '../PayButtons'
import { SummaryBox } from '../styles'

type Props = {
  order: Order | undefined
  orderItemId: number | undefined
  isProlonging: boolean
  isReconciliation: boolean
  purchaseAs: string
  showCancelButton?: boolean
  disabledCancelOrderButton?: boolean
  cancelOrderProcessor?: () => void
}

export const SummaryBoxPanel: React.FC<Props> = ({
  order,
  orderItemId,
  isProlonging,
  isReconciliation,
  purchaseAs,
  showCancelButton = true,
  disabledCancelOrderButton,
  cancelOrderProcessor,
}) => {
  const { customerInfo } = useCustomerInfo()

  const invoiceIsAllowed = () => {
    if (order?.invoiceAllowed === true) {
      return true
    }

    if (customerInfo.organization) {
      return customerInfo.organization.trustedCustomer
    }

    if (customerInfo.customer?.trustedCustomer) {
      return true
    }

    return false
  }

  return (
    <Flex marginTop="42px" direction={{ base: 'column', lg: 'row' }} justifyContent={{ lg: 'space-between' }}>
      <SummaryBox>
        <Flex width="100%" direction="row" justifyContent="space-between">
          <SummaryPriceInfo isProlonging={isProlonging} isReconciliation={isReconciliation} order={order} />

          {showCancelButton && order && order.status !== OrderPaymentStatus.started && (
            <Box>
              <OrderCardDeleteButton isDisabled={disabledCancelOrderButton} onClick={cancelOrderProcessor}>
                {disabledCancelOrderButton ? <Loader /> : <LuTrash2 />}
              </OrderCardDeleteButton>
            </Box>
          )}
        </Flex>
        <PayButtons
          isReconciliation={isReconciliation}
          orderId={order?.id ?? 0}
          orderItemId={orderItemId}
          purchaseAs={purchaseAs}
          isZeroPayment={order?.totalPrice === 0}
          isLoading={!order}
          invoiceAllowed={invoiceIsAllowed()}
        />
      </SummaryBox>
    </Flex>
  )
}
